import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';
import React from 'react';

export const StarburstIcon = createIcon({
  viewBox: '0 0 110 99',
  path: (
    <g fill="none">
      <path
        d="M103.04 40.036c-10.901 4.006-7.296 11.287 2.076 14.922-17.121-2.943-17.327 5.602-7.057 18.804-8.293-7.902-20.475-17.278-5.402 12.95-15.195-20.49-19.968-10.029-15.072-2.338-7.642-9.245-19.173-6.044-21.926 11.162-4.49-30.569-17.329-6.721-24.504 3.01C41.236 72.148 28.535 71.738 1.558 85.3 20.232 72.72 25.262 54.456.687 53.98c23.425-2.037 23.957-10.007.88-20.218 23.738 7.37 17.094-1.544 13.05-8.546 8.624 2.79 16.023 2.821 1.357-16.658 21.8 18.182 23.06 11.608 18.593 1.843 6.056 8.706 17.456 11.002 16.548-1.157C55.515 24.6 66.508 22.734 71.835.51c-2.22 33.033 10.654 21.157 20.753 9.774-5.747 8.833-11.352 25.44 16.941 13.483-18.598 10.38-15.37 19.634-6.478 16.418.114-.008-.671.247 0 0"
        fill="none"
        stroke="white"
        strokeWidth={2}
      />
      <path
        fill="red"
        d="M103.04 40.036c-10.901 4.006-7.296 11.287 2.076 14.922-17.121-2.943-17.327 5.602-7.057 18.804-8.293-7.902-20.475-17.278-5.402 12.95-15.195-20.49-19.968-10.029-15.072-2.338-7.642-9.245-19.173-6.044-21.926 11.162-4.49-30.569-17.329-6.721-24.504 3.01C41.236 72.148 28.535 71.738 1.558 85.3 20.232 72.72 25.262 54.456.687 53.98c23.425-2.037 23.957-10.007.88-20.218 23.738 7.37 17.094-1.544 13.05-8.546 8.624 2.79 16.023 2.821 1.357-16.658 21.8 18.182 23.06 11.608 18.593 1.843 6.056 8.706 17.456 11.002 16.548-1.157C55.515 24.6 66.508 22.734 71.835.51c-2.22 33.033 10.654 21.157 20.753 9.774-5.747 8.833-11.352 25.44 16.941 13.483-18.598 10.38-15.37 19.634-6.478 16.418.114-.008-.671.247 0 0"
      />
    </g>
  ),
});
